export default __webpack_public_path__ + "static/media/disabledWallet.28878773.svg";